import React from "react";

const MARK_URL =
  "https://customer-assets.emergentagent.com/job_founder-brand-audit/artifacts/l3rrkxb3_The_Weave_Logo_Symbol_only_Transparent_resize_50.png";

// "the" (red) + "weave" (teal) wordmark + the official tri-triangle PNG mark
export default function WeaveLogo({ height = 30, withMark = true, className = "", color = "default" }) {
  const teal = color === "cream" ? "#fbf7f0" : "var(--teal)";
  const red = color === "cream" ? "#fbf7f0" : "var(--red)";
  return (
    <span
      className={`inline-flex items-center gap-2 ${className}`}
      style={{ height }}
      data-testid="weave-logo"
      aria-label="The Weave"
    >
      <span
        className="font-display"
        style={{
          color: red,
          fontSize: height * 0.55,
          fontWeight: 700,
          letterSpacing: "-0.02em",
          lineHeight: 1,
          transform: "translateY(-2px)",
        }}
      >
        the
      </span>
      <span
        className="font-display"
        style={{
          color: teal,
          fontSize: height * 1.0,
          fontWeight: 800,
          letterSpacing: "-0.045em",
          lineHeight: 1,
        }}
      >
        weave
      </span>
      {withMark && (
        <img
          src={MARK_URL}
          alt=""
          aria-hidden="true"
          style={{
            height: height * 1.0,
            width: "auto",
            marginLeft: 6,
            objectFit: "contain",
          }}
        />
      )}
    </span>
  );
}
